/**
 * Whether a successful /seo/redirect target needs a new history entry.
 * Same href → no-op (avoid duplicate identical entries).
 */
export const shouldPushSeoRedirectHistory = (currentHref: string, toUrl: string): boolean =>
  currentHref !== toUrl;

/**
 * Apply a successful /seo/redirect target to the browser history stack.
 *
 * Must not mutate the previous history entry (e.g. strip ?characters= via
 * replaceState(pathname) before push). That erased pass-through filter URLs
 * so browser Back skipped them after a later permalink push.
 */
export const pushSeoRedirectHistory = (toUrl: string): void => {
  const currentHref = `${window.location.pathname}${window.location.search}`;
  if (!shouldPushSeoRedirectHistory(currentHref, toUrl)) {
    return;
  }

  window.history.pushState({}, '', toUrl);
};

/**
 * Re-assert the canonical redirect URL on the current entry after filter/
 * meta side effects that may have raced and appended query params.
 */
export const reassertSeoRedirectHistory = (toUrl: string): void => {
  window.history.replaceState({}, '', toUrl);
};
